// src/features/explore/PeopleResults.tsx — people result grid (content-type = People).
// The per-person card lives in PersonCard.tsx (shared with SearchResults).
import styled from 'styled-components';
import { useSuggestedProfiles } from '@/hooks';
import { filterPeople } from './filterExplore';
import { PersonCard } from './PersonCard';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 12px;
`;
const Empty = styled.div`
  padding: 28px 16px; text-align: center;
  font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
  background: ${({ theme }) => (theme.cardsGlass ? 'transparent' : theme.color.surface)};
  border-radius: ${({ theme }) => theme.radius.md};
`;

export interface PeopleResultsProps {
  search: string;
}

export function PeopleResults({ search }: PeopleResultsProps) {
  const profiles = useSuggestedProfiles();
  const visible = filterPeople(profiles, search);
  // Only blame the search when there is one — an empty box is not a search, and
  // "No people match your search" for a member who typed nothing reads as broken.
  if (visible.length === 0) {
    return <Empty>{search.trim() ? 'No people match your search.' : 'No people to suggest yet.'}</Empty>;
  }
  return (
    <Grid>
      {visible.map((p) => (
        <PersonCard key={p.handle} profile={p} />
      ))}
    </Grid>
  );
}
